// extracted by mini-css-extract-plugin
module.exports = {"embla__slide":"listing-carousel-slide_embla__slide__iPVSd","embla__slide__img":"listing-carousel-slide_embla__slide__img__BprjN"};